import amplitudeEventNames from '@/consts/analytics/analyticsEventNames';
import analyticsEventProperties from '@/consts/analytics/analyticsEventProperties';
import {amplitude} from '@/services/analytics/amplitude/index';

const trackSplashScreenViewed = () => {
    amplitude.trackWithSource(amplitudeEventNames.WELCOME_SPLASH_SCREEN_VIEWED);
};

const trackAppUpdatePopupViewed = () => {
    amplitude.trackWithSource(amplitudeEventNames.APP_UPDATE_POPUP_VIEWED);
};

const trackAppUpdateButtonClicked = () => {
    amplitude.trackWithSource(amplitudeEventNames.APP_UPDATE_BUTTON_CLICKED);
};

const trackMaintenancePopupViewed = () => {
    amplitude.trackWithSource(amplitudeEventNames.MAINTENANCE_POPUP_VIEWED);
};

const trackFeedbackPopupViewed = () => {
    amplitude.trackWithSource(amplitudeEventNames.FEEDBACK_POPUP_VIEWED);
};

const trackFeedbackSubmitted = (success) => {
    amplitude.trackWithSource(amplitudeEventNames.FEEDBACK_SUBMITTED, {[analyticsEventProperties.SUCCESS]: success});
};

export default {
    trackSplashScreenViewed,
    trackAppUpdatePopupViewed,
    trackAppUpdateButtonClicked,
    trackMaintenancePopupViewed,
    trackFeedbackPopupViewed,
    trackFeedbackSubmitted,
};
